/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_ThrottledInputs */

const fr_error_throttled = /** @type {(inputs: Error_ThrottledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop de tentatives. Réessayez dans un instant.`)
};

const en_error_throttled = /** @type {(inputs: Error_ThrottledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many attempts. Try again shortly.`)
};

/**
* | output |
* | --- |
* | "Too many attempts. Try again shortly." |
*
* @param {Error_ThrottledInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_throttled = /** @type {((inputs?: Error_ThrottledInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_ThrottledInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_throttled(inputs)
	return fr_error_throttled(inputs)
});